import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function FeaturedCategories() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="categories-title">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 id="categories-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选品类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            涵盖国产美妆、数码、食品、服饰等热门品类，一站式发现优质国货
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.id}`}
              className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
              onMouseEnter={() => setHoveredId(cat.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    hoveredId === cat.id ? 'scale-110' : 'scale-100'
                  }`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/60 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <h3 className="text-lg font-heading font-semibold text-white">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-white/80 mt-1">{cat.count}篇内容</p>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}